import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircle, faEye } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Badge } from 'react-bootstrap';
import SetView from '../../../components/dbqSets/SetView';
import { useGetSetQuestionsMutation } from '../../../../../features/authentication/questionSearchApiSlice';
import { useAssignmentContext } from '../../../../assignments/context';

const SetThumbnail = ({
  setDetails,
  setSetDetails,
  setSelectedSetIds,
  selectedSetIds,
  isLoading,
  selectedCourseId
}) => {
  const [getSetQuestions] = useGetSetQuestionsMutation();
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [openItems, setOpenItems] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [bookletStartClicked, setBookletStartClicked] = useState(false);
  const [selectedSetId, setSelectedSetId] = useState(0);
  const { setHasPendingChanges } = useAssignmentContext();

  const handleSetSelection = (setId, selected) => {
    let newSetDetails = setDetails.map((item) =>
      item.setId === setId ? { ...item, isSelected: selected } : item
    );
    const currentSelectedSetIds = [...selectedSetIds];
    if (selected) {
      currentSelectedSetIds.push(setId);
      setHasPendingChanges(true);
    }
    else {
      const index = currentSelectedSetIds.findIndex(integer => integer === setId);
      if (index !== -1) {
        currentSelectedSetIds.splice(index, 1);
        setHasPendingChanges(currentSelectedSetIds.length > 0);
      }
    }
    setSelectedSetIds(currentSelectedSetIds);
    setSetDetails(newSetDetails);
  };

  const handlePreview = async (setId, languageId) => {
    setSelectedSetId(setId);
    setBookletStartClicked(false);
    setPreviewData(null);
    setOpenPreviewModal(true);
    const option = {
      courseId: selectedCourseId,
      setId: setId,
      languageId: languageId
    };
    var result = await getSetQuestions(option).unwrap();
    setPreviewData(result);
    setOpenItems(result.setQuestions.map(() => false));
  };

  const togglePreviewQuestions = (isBooklet, index) => {
    setOpenItems((prevOpenItems) =>
      prevOpenItems.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );

    if (isBooklet) {
      const container = document.querySelector('table.booklet').closest('div');
      const startPageElement = container.querySelector('#page0');
      startPageElement.style.display = 'none';
    }
  };

  return (
    <>
      {!isLoading ? (
        <>
          {setDetails &&
            <div className='questionsGrid'>
              {setDetails.map((set, index) => (
                <>
                  <div key={index} className='questionThumbnail cursor-pointer justify-content-start'>
                    <div className='selectBtns'>
                      <div className='d-flex flex-row justify-content-between'>
                        <div></div>
                        <div className='questionThumbnailButtons' onClick={() => handleSetSelection(set.setId, !set.isSelected)}>
                          {set.isSelected ?
                            <FontAwesomeIcon color='#52C9A5' icon={faCircleCheck} />
                            :
                            <FontAwesomeIcon color='#d4deff' icon={faCircle} />}
                        </div>
                      </div>
                    </div>
                    <div className='d-flex w-100'>
                      <div className='fw-500 w-100'>{set.label}</div>
                      {set.isNew &&
                        <Badge className='bg-warning'>New</Badge>
                      }
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: set.subTopics }}></p>
                    <div className='line'></div>
                    <div className='d-flex w-100'>
                      <div className='flex-fill'>Lexile: {set.lexile}</div>
                      <div>Question: {set.questionCount}</div>
                    </div>
                    <div className='line'></div>
                    <div dangerouslySetInnerHTML={{ __html: set.description }}></div>
                    {set.spanish.length > 0 &&
                      <>
                        <p>Spanish Translation</p>
                        <div dangerouslySetInnerHTML={{ __html: set.spanish }}></div>
                      </>
                    }
                    <div className="w-100 thumbnail-view" onClick={() => handlePreview(set.setId, 0)}>
                      <div className="d-none thumbnail-view-button">
                        {' '}
                        <FontAwesomeIcon icon={faEye} />
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          }
        </>
      ) : (
        <div className="w-100 row">
          {[...Array(4)].map((_, index) => (
            <div className='col-3 mb-3 h-40' key={index}>
              <Skeleton />
            </div>
          ))}
          {[...Array(4)].map((_, index) => (
            <div className='col-3 mb-3 h-40' key={index}>
              <Skeleton />
            </div>
          ))}
        </div>
      )}
      {!isLoading && setDetails.length === 0 &&
        <div className='noResultsContainer'>
          <div className='noResultsBox w-100'>
            <div className='fw-500'>No sets were found matching your filter(s).  Please try another search.</div>
          </div>
        </div>}
      {openPreviewModal &&
        <SetView
          openPreviewModal={openPreviewModal}
          setOpenPreviewModal={setOpenPreviewModal}
          previewData={previewData}
          openItems={openItems}
          togglePreviewQuestions={togglePreviewQuestions}
          setBookletStartClicked={setBookletStartClicked}
          bookletStartClicked={bookletStartClicked}
          isDbqSet={false}
          handlePreview={handlePreview}
          selectedSetId={selectedSetId}
        />
      }
    </>
  );
};

SetThumbnail.propTypes = {
  setDetails: PropTypes.array.isRequired,
  setSetDetails: PropTypes.func,
  setSelectedSetIds: PropTypes.func,
  selectedSetIds: PropTypes.array,
  isLoading: PropTypes.bool,
  selectedCourseId: PropTypes.number
};

export default SetThumbnail;